module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#twitter",
      toString: function () {
        return this.url;
      }
    }